import * as tradesmanSequence from '_services/tradesman-sequence'
import { defineAction } from '_utils/redux'

export const CREATE_TRADESMAN_SEQUENCE = defineAction('CREATE_TRADESMAN_SEQUENCE')
export const ACCEPT_BY_TRADESMAN = defineAction('ACCEPT_BY_TRADESMAN')
export const ACCEPT_IB_BY_TRADESMAN = defineAction('ACCEPT_IB_BY_TRADESMAN')
export const GET_TRADESMAN_SEQUENCE = defineAction('GET_TRADESMAN_SEQUENCE')

export const createTradesmanSequence = (serviceOrderId, payload) => async (dispatch, getState) => {
  const data = await tradesmanSequence.createTradesmanSequence(
    getState().user.authToken,
    serviceOrderId,
    payload
  )
  dispatch({
    type: CREATE_TRADESMAN_SEQUENCE,
    payload: async () => data,
  })

  return data
}

export const getTradesmanSequence = serviceOrderId => (dispatch, getState) =>
  dispatch({
    type: GET_TRADESMAN_SEQUENCE,
    payload: tradesmanSequence.getTradesmanSequence(getState().user.authToken, serviceOrderId),
  })

export const acceptByTradesman = (serviceOrderId, payload) => async (dispatch, getState) => {
  const data = await tradesmanSequence.acceptByTradesmanService(
    getState().user.authToken,
    serviceOrderId,
    payload
  )

  dispatch({
    type: ACCEPT_BY_TRADESMAN,
    payload: async () => data,
  })

  return data
}

export const acceptIBByTradesman = (serviceOrderId, payload) => async (dispatch, getState) => {
  const data = await tradesmanSequence.acceptIBByTradesmanService(
    getState().user.authToken,
    serviceOrderId,
    payload
  )

  dispatch({
    type: ACCEPT_IB_BY_TRADESMAN,
    payload: async () => data,
  })

  return data
}
